module.exports = __webpack_public_path__ + "static/media/designer_bg.98c69c84.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Account/assets/designer_bg.png
// module id = 1175
// module chunks = 0